import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=b2783bbc&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=b2783bbc&prod&scoped=true&lang=css"
import style1 from "./Delivery.vue?vue&type=style&index=1&id=b2783bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2783bbc",
  null
  
)

export default component.exports